//новости образования
$('.news__subscribe').on('click', function(){
	$('.popup-news').addClass('active');
	$('body').addClass('no-scroll');
});
//профориентация по скайпу
$('.orient__btn-skype').on('click', function(){
	$('.popup-skype').addClass('active');
	$('body').addClass('no-scroll');
});
//профориентация профориентатор
$('.orient__btn-proforientator').on('click', function(){
	$('.popup-proforientator').addClass('active');
	$('body').addClass('no-scroll');
});
//профориентация профнавигатор
$('.orient__btn-profnavigator').on('click', function(){
	$('.popup-profnavigator').addClass('active');
	$('body').addClass('no-scroll');
});
//профориентация профкарьера
$('.orient__btn-profcareer').on('click', function(){
	$('.popup-profcareer').addClass('active');
	$('body').addClass('no-scroll');
});
//экспресс-тест
$('.express__btn').on('click', function(){
	$('.popup-express').addClass('active');
	$('body').addClass('no-scroll');
});

//success
//пользовательское соглашение
$('.agree').on('click', function(e){
	e.preventDefault();
	$('.popup-agree').addClass('active');
});

//закрыть модальное окно по клику на крестик
$('.popup__close').on('click', function(){
	$(this).parents('.popup').removeClass('active');
	$('body').removeClass('no-scroll');
});

//закрыть модальное окно по клику вне окна
$('.popup').on('click', function(e){
	if(e.target == this) {
		$(this).removeClass('active');
		$('body').removeClass('no-scroll');
	}
})

//закрыть календарь/выбор времени по клику на модальное окно вне календаря/выбора времени

$('.popup__container').on('click', function(e){

	//если календарь виден
	if(!$('#dateContent').hasClass('off')){
		//если клик не по календарю и его содержимому
		if ((!$('#calendar').is(e.target) && $('#calendar').has(e.target).length === 0 
			&& !$('#date').is(e.target))) { //и если клик не по инпуту с выбором даты
			//то спрятать календарь
			$('#dateContent').addClass('off');
		}
	}
	if(!$('#timeContent').hasClass('off')){
		if (!$('#timeContent').is(e.target) && $('#timeContent').has(e.target).length === 0 
			&& !$('#time').is(e.target)) { 
			$('#timeContent').addClass('off');
		}
	}
}) 


